export function getImagePath(path: string) {
    try {
        if (path.includes('http://') || path.includes('https://') || path.includes('data:')) {
            return path;
        } else {
            return `${process.env.GATSBY_MEDIA_URL || ""}/${path.replace(/^\/media/, '').replace(/^\//, '')}`;
        }
    } catch (err) {
        console.error(`Failed to get image path for: ${path}`);
        return path || '';
    }
}

/**
 * Adds slash to Beginning and End of search and searched path strings,
 * this way it matches urls where pattern ends with / but url doesn't end with /
 */
 export function normalizePath(str: string) {
    const firstChar = (str[0] === "/") ? "" : "/";
    const lastChar = (str[str.length - 1] === "*") ? "" : "/";
    return `${firstChar}${str.toLowerCase()}${lastChar}`;
}

/**
 * Converts search string into regex expression, changes * into .* and escapes slashes
 * @param path: string
 */
 export function getRegexFromString(path: string) {
    const normalizedPath = path.match(/^https:/i) ? path : normalizePath(path);
    const parsedPath = normalizedPath.replace(/\*/g, ".*").replace(/\//g, "\\/");
    return new RegExp("^" + parsedPath + "$");
}
